import { render, staticRenderFns } from "./BaseTouchSpin.vue?vue&type=template&id=e5a2e822&scoped=true&"
import script from "./BaseTouchSpin.vue?vue&type=script&lang=js&"
export * from "./BaseTouchSpin.vue?vue&type=script&lang=js&"
import style0 from "./BaseTouchSpin.vue?vue&type=style&index=0&id=e5a2e822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a2e822",
  null
  
)

export default component.exports